"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDBToRate = exports.convertDBToDecimal = void 0;
/**
 * Transforms the number from database format to decimal format.
 *
 * The database format consider the two last numbers as decimal numbers.
 * E.g: `$10000` actually represents `$100,00`.
 * @param value Value in database format
 * @returns Value in decimal format
 */
const convertDBToDecimal = (value) => value / 100;
exports.convertDBToDecimal = convertDBToDecimal;
/**
 * Transforms the number from database format to decimal format and converts it to a rate (0-1).
 *
 * The database format consider the two last numbers as decimal numbers.
 * E.g: `1000` actually represents `10%` which is a rate of `0.1`.
 * @param value Value in database format
 * @returns Value in decimal rate format
 */
const convertDBToRate = (value) => value / 100 / 100;
exports.convertDBToRate = convertDBToRate;
